import React, {useState} from "react";
import { useTranslation } from "react-i18next"

import {ForEyeCareProfessionals, ForPatientsAndCaregivers} from "./components";
import {ChildTabsComponent} from "../components"
import resourcesTrans from "./transMessage"


export const Resources = () => {
    const { t } = useTranslation()
    const [resourceTabValue, setResourceTabValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setResourceTabValue(newValue);
    };

    const resourceTabs = [
        {
            tabLabel: t(resourcesTrans.FOR_EYE_CARE_PROFESSIONALS),
            children: <ForEyeCareProfessionals/>
        },
        {
            tabLabel: t(resourcesTrans.FOR_PATIENTS_AND_CAREGIVERS),
            children: <ForPatientsAndCaregivers/>
        }
    ]

    return (
        <ChildTabsComponent
            tabsList={resourceTabs}
            value={resourceTabValue}
            handleChange={handleChange}
        />
    )
}
